module.exports = __webpack_public_path__ + "img/MEGADICE.997c9058.svg";